// removed by extract-text-webpack-plugin
module.exports = {"docLayout":"_2lE56","body":"_1Ih7a","bodyVisible":"_1GU64","backdrop":"mu2P9"};


/*****************
 ** WEBPACK FOOTER
 ** ./web_modules/LayoutContainer/index.css
 ** module id = 468
 ** module chunks = 0
 **/